import useDim from "src/hooks/useDim";

const useFooterGradientHeight = () => {
	const dim = useDim();
	return 0.1 * dim.height;
};
export default useFooterGradientHeight;
